import React from 'react'

function QuickContact() {
  return (
    <div className='quick-contact'>Tel : 055 000 0000 | email : info@softec.com | Location : Taifa Burkina - Behind Prudential Bank</div>
)
}

export default QuickContact